export default "__VITE_ASSET__D9ncIpJG__"